import { StoreSetupDraft } from '../../types/storeSetup.types';

export type SetupBeat = {
  phase: 'think' | 'place' | 'done';
  label: string;
  itemId: string | null;
};

export function setupIds(setup: StoreSetupDraft): string[] {
  return [
    ...setup.statuses,
    ...setup.searches,
    ...setup.charts,
    ...setup.automations,
    ...setup.fields
  ].map((item) => item.id);
}

export function setupHasDraft(setup: StoreSetupDraft): boolean {
  return setupIds(setup).length > 0;
}

export function setupSectionLabel(setup: StoreSetupDraft, id: string): string {
  if (setup.statuses.some((item) => item.id === id)) return 'Statuts';
  if (setup.searches.some((item) => item.id === id)) return 'Recherches';
  if (setup.charts.some((item) => item.id === id)) return 'Graphiques';
  if (setup.automations.some((item) => item.id === id)) return 'Automatisations';
  if (setup.fields.some((item) => item.id === id)) return 'Champs';
  return 'Setup';
}

export function setupChunks(setup: StoreSetupDraft, ids: string[]): Array<{ label: string; ids: string[] }> {
  const chunks: Array<{ label: string; ids: string[] }> = [];
  ids.forEach((id) => {
    const section = setupSectionLabel(setup, id);
    const last = chunks[chunks.length - 1];
    if (last && last.label === section) last.ids.push(id);
    else chunks.push({ label: section, ids: [id] });
  });
  return chunks.map((chunk) => ({
    label: chunk.ids.length === 1 ? setupItemLabel(setup, chunk.ids[0]) : chunk.label,
    ids: chunk.ids
  }));
}

export function setupItemLabel(setup: StoreSetupDraft, id: string): string {
  const status = setup.statuses.find((item) => item.id === id);
  if (status) return `Statut · ${status.name}`;
  const search = setup.searches.find((item) => item.id === id);
  if (search) return `Recherche · ${search.name}`;
  const chart = setup.charts.find((item) => item.id === id);
  if (chart) return `Graphique · ${chart.name}`;
  const automation = setup.automations.find((item) => item.id === id);
  if (automation) return `Automatisation · ${automation.name}`;
  const field = setup.fields.find((item) => item.id === id);
  if (field) return `Champ · ${field.name}`;
  return 'Setup';
}

export function setupStepDelay(): number {
  if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return 40;
  }
  return 420;
}

export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}
